exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  top: 85px;\n  width: 65%;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);\n  margin-right: auto;\n  margin-left: auto;\n  border: solid;\n  border-width: 1px;\n  border-color: #f7f7f7; }\n\n.card-header {\n  height: 40px;\n  padding: 6px !important;\n  background-color: #f7f7f7; }\n\n.card-title {\n  font-size: 16px;\n  font-weight: normal;\n  margin-bottom: 0;\n  padding-top: 6px;\n  padding-left: 10px; }\n\n.card-block {\n  padding: 0; }\n\ntable {\n  width: 100%; }\n  table tr {\n    font-size: 12px; }\n    table tr td {\n      margin-left: 5px;\n      padding-bottom: 5px;\n      padding-top: 5px; }\n\n.data-table .data-table__header .row {\n  display: -ms-flexbox;\n  display: flex; }\n  .data-table .data-table__header .row .form-group {\n    margin-bottom: 10px; }\n\n.data-table__footer {\n  padding: 15px 10px 5px;\n  background-color: #f7f7f7; }\n  .data-table__footer pagination {\n    float: left;\n    padding-left: 25px; }\n\n.data-table__footer .btn-toolbar {\n  float: right;\n  margin-right: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/visualiza-cadastro/visualiza-cadastro.component.scss
// module id = ../../../../../src/app/angular-base-ui/visualiza-cadastro/visualiza-cadastro.component.scss
// module chunks = 1